<template>
  <div>
    <About v-if="pageName === 'About'" />
    <Careers v-if="pageName === 'Careers'" />
    <Documents v-if="pageName === 'Documents'" />
    <Sales v-if="pageName === 'Sales'" @add-swatch-to-cart="addSwatchToCart" />
    <Brands v-if="pageName === 'Brands'" />
  </div>
</template>

<script>
  import About from './pages/about.vue';
  import Careers from './pages/careers.vue';
  import Documents from './pages/documents.vue';
  import Sales from './pages/sales.vue';
  import Brands from './pages/brands.vue';

  export default {
    name: 'container',

    components: {
      About,
      Careers,
      Documents,
      Sales,
      Brands,
    },

    data() {
      return {
        pageName: this.$root.pageName,
      };
    },

    methods: {
      addSwatchToCart(swatch) {
        this.$emit("add-swatch-to-cart", swatch);
      },
    }
  };
</script>